import React, { useEffect, useState } from "react";
import { ArrowUpCircle, RefreshCw } from "lucide-react";
import { useApp } from "../context/AppContext";
import { subscribeAppVersion, openStore } from "../lib/appVersion";
import { subscribeLiveUpdate, applyPendingLiveUpdate } from "../lib/liveUpdate";

// Yellow bar under the menus (native only) while the installed app is older
// than the version published on the App Store / Google Play.
export const UpdateBanner = () => {
  const { t } = useApp();
  const [status, setStatus] = useState(null);
  const [live, setLive] = useState(null);
  useEffect(() => subscribeAppVersion(setStatus), []);
  useEffect(() => subscribeLiveUpdate(setLive), []);
  if (live?.state === "ready" || live?.state === "applying") {
    return (
      <button
        type="button"
        data-testid="live-update-banner"
        disabled={live.state === "applying"}
        onClick={() => applyPendingLiveUpdate()}
        className="shrink-0 w-full bg-emerald-500 text-emerald-950 flex items-center justify-center gap-2 px-3 py-2 text-xs font-semibold active:bg-emerald-600 transition-colors"
        style={{ paddingBottom: "max(calc(env(safe-area-inset-bottom, 0px) + 6px), 8px)" }}
      >
        <RefreshCw className={`h-4 w-4 shrink-0 ${live.state === "applying" ? "animate-spin" : ""}`} />
        <span className="truncate">{live.state === "applying" ? t("live_update_applying") : t("live_update_ready")}</span>
      </button>
    );
  }
  if (!status?.outdated) return null;
  return (
    <button
      type="button"
      data-testid="app-update-banner"
      onClick={() => openStore(status.platform)}
      className="shrink-0 w-full bg-amber-400 text-amber-950 flex items-center justify-center gap-2 px-3 py-2 text-xs font-semibold active:bg-amber-500 transition-colors"
      style={{ paddingBottom: "max(calc(env(safe-area-inset-bottom, 0px) + 6px), 8px)" }}
    >
      <ArrowUpCircle className="h-4 w-4 shrink-0" />
      <span className="truncate">{t("app_update_banner")} · {status.latest}</span>
    </button>
  );
};

export const useAppOutdated = () => {
  const [status, setStatus] = useState(null);
  useEffect(() => subscribeAppVersion(setStatus), []);
  return !!status?.outdated;
};
